export abstract class AEntity {
    public abstract getId():string;
    public abstract toJSON(): object;
}
